import React, { useState } from "react";
import SwitchToDesktopModal from "./SwitchToDesktopModal";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";

const SubHeader = (props) => {
  const history = useHistory();

  // ============> Switch to desktop modal fyi: Only works for mobile users<=============
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="subheader ">
      <div className="container-fluid max-w-screen-xl m-auto text-center">
        <h1 className="text-white mb-4">{props.title}</h1>
        <p className="max-w-screen-md m-auto text-white mb-4">
          {props.description}
        </p>
        {props.isLoggedIn ? (
          <>
            <button
              className="btn-custom bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-full mt-5"
              onClick={() => {
                if (isMobile && props.buttonName === "CREATE POST") {
                  showModal();
                } else {
                  props.buttonClicked();
                }
              }}
            >
              {props.buttonName}
            </button>

            <SwitchToDesktopModal
              handleOk={handleOk}
              showModal={showModal}
              isModalOpen={isModalOpen}
            />
          </>
        ) : (
          <button
            className="btn-custom bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-full mt-5"
            onClick={() => {
              history.push("/search/1/posts");
            }}
          >
            SEARCH
          </button>
        )}
      </div>
      {props.children}
    </div>
  );
};

export default SubHeader;
